import { computed } from "vue";
import { useCookies } from "vue3-cookies";
import { cookiesConf } from "@erp/shared/const/cookies";
import { GROUP_ID } from "../types/user.types";
import { useLoginInfo } from "./useLoginInfo";
/**
 * @description 권한 확인 컴포저블
 * @returns
 * - pricePermission: 가격 노출 권한 여부
 * - stockSearchPermission: 재고 조회 권한 여부
 * - isAdmin: 관리자 권한 여부
 * - isMe: 본인 확인용
 */
export const usePermission = () => {
    const PRICE_PERMISSION_GROUP_IDS = [GROUP_ID.관리자, GROUP_ID.자재금액노출];
    const STOCK_CHECK_PERMISSION_GROUP_ID = [
        ...PRICE_PERMISSION_GROUP_IDS,
        GROUP_ID.재고조회,
    ];
    const { cookies } = useCookies();
    const currentUser = useLoginInfo();
    const getCurrentGroupIds = () => {
        const raw = cookies.get(cookiesConf.permission_group_ids.key);
        if (raw == null || raw === "")
            return []; // 쿠키 없으면 권한 없음 처리
        return String(raw).split(",");
    };
    // 금액 노출 권한 여부
    const pricePermission = computed(() => {
        const currentGroupIds = getCurrentGroupIds();
        const permissionComfirm = currentGroupIds.some((id) => PRICE_PERMISSION_GROUP_IDS.includes(id));
        return permissionComfirm;
    });
    // 재고 조회 권한 여부
    const stockSearchPermission = computed(() => {
        const currentGroupIds = getCurrentGroupIds();
        const permissionComfirm = currentGroupIds.some((id) => STOCK_CHECK_PERMISSION_GROUP_ID.includes(id));
        return permissionComfirm;
    });
    // 관리자 권한 여부
    const isAdmin = computed(() => {
        const currentGroupIds = getCurrentGroupIds();
        return currentGroupIds.includes(GROUP_ID.관리자);
    });
    // 본인 확인용
    const isMe = (userId) => {
        return currentUser.id.value === userId;
    };
    return {
        pricePermission,
        stockSearchPermission,
        isMe,
        isAdmin,
    };
};
